import { Button, Col, Row, Switch } from "antd";
import Loading from "components/Loading";
import ClickOutside from "components/OnClickOutside";
import { find } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { DebateLftIcon, DebateRgtIcon } from "utils/assets/images";
import { bingoImageUrl } from "utils/config/reference";
import BingoTeacherWin from "./BingoResultScreens/BingoTeacherWin";
import PlayThemeSong from "./playThemeSong/playThemeSong";
import GridView from "./teacher/gridView";
import ViewMyLoteria from "./teacher/viewMyLoteria";
import SentryWrap from 'components/Sentry';

const LoaderWrapper = styled.div`
  // position:absolute;
  z-index: 100;
`;

const BingoStudentDetail = ({
  bingoEndScreen,
  debateInfo,
  studentSubmission,
  resultLoader,
  indexs,
  handleClickAnswerDetail = () => null,
  handleEvaluation = () => null,
  wheelSpinResult = [],
  showNames,
  setShowNames,
  showSnack,
  // Theme song props
  themeSongProps = {}
}) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [openMyLoteria, setOpenMyLoteria] = useState(false);
  const [viewResultWheel, setViewResultWheel] = useState(false);
  const MatchType = debateInfo?.configurations?.bingo_type === 'OnlyImage' ? "OnlyImage" : debateInfo?.bingo_type || "Image";
  const bingoWinnerData = find(
    studentSubmission,
    (item) => item?.teacher_response === "accept"
  );

  useEffect(() => {
    const initialSlideIndex = studentSubmission.findIndex(
      (item) => item.submission_id === indexs // Replace desiredSubmissionId with the actual value
    );
    setCurrentQuestionIndex(initialSlideIndex);
  }, [studentSubmission, indexs])

  const handleNext = () => {
    if (currentQuestionIndex < studentSubmission.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleEvaluationResult = async (value) => {
    if (currentQuestionIndex === -1 || !studentSubmission[currentQuestionIndex]) {
      console.error("Invalid currentQuestionIndex or submission not found");
      showSnack("Unable to process submission. Please try again.", "error");
      return;
    }
    if (value === "reject") {
      handleClickAnswerDetail();
    }
    await handleEvaluation(
      studentSubmission[currentQuestionIndex],
      value
    );
    if (value === "reject") {
      showSnack("Submission rejected successfully!", "success");
    }
  };

  const hide = () => {
    setOpenMyLoteria(false);
  };
  const handleOpenChange = () => {
    setViewResultWheel(false);
    setOpenMyLoteria((prev) => !prev);
  };

  const handleOpenChangeForWheelResult = () => {
    setOpenMyLoteria(false);
    setViewResultWheel((prev) => !prev);
  };

  const bingoType = useMemo(() => {
    return debateInfo?.configurations?.bingo_type === 'OnlyImage' ? "OnlyImage" : debateInfo?.bingo_type || "";
  }, [debateInfo?.bingo_type]);

  const bingoData = useMemo(() => {
    if (debateInfo?.bingo_data) {
      return JSON.parse(debateInfo?.bingo_data);
    } else {
      return [];
    }
  }, [debateInfo?.bingo_data]);

  const wheelSpinData = useMemo(() => {
    return (
      bingoData?.map((bingoItem) => {
          const isInWheelSpin = wheelSpinResult.some(
            (wheelItem) => wheelItem.id === bingoItem.id
          );
          return {
            ...bingoItem,
            selected: isInWheelSpin,
          };
        })
        .filter((data) => data?.selected) || []
    );
  }, [bingoData, wheelSpinResult]);

  const bingoWheelSpinData = useMemo(() => {
    return (
      bingoData?.map((bingoItem) => {
          const isInWheelSpin = wheelSpinResult.some(
            (wheelItem) => wheelItem.id === bingoItem.id
          );
          return {
            ...bingoItem,
            selected: isInWheelSpin,
          };
        })
    );
  }, [bingoData, wheelSpinResult]);

  const currentSubmission = studentSubmission[currentQuestionIndex];
  const answerText =
    (currentSubmission?.answer_text && JSON?.parse(currentSubmission?.answer_text)) || [];

  return (
    <SentryWrap>
      {bingoEndScreen && (
        <div className="bingo-win-div">
          <BingoTeacherWin bingoWinnerData={bingoWinnerData} />
        </div>
      )}
      {!bingoEndScreen && (
        <div className="ideaMdlUpr">
          <div
            className="debateBackBtn"
            onClick={() => handleClickAnswerDetail()}
          >
            <img src={DebateLftIcon} alt="Debate" />
          </div>
          <Row>
            <Col xs={24}>
              <div className="debateMdlTop debateAllTopTxt debateTopBckBtn debateAllTopSpace bingoTopSection bingo-student-detail">
                <div style={{ display: "flex" }} className="bingoTopTxt">
                  <img
                    className="bingo-logo newBingoLogo"
                    src={bingoImageUrl}
                    alt="Debate"
                  />
                  <div className="topSliderHeaderTxt bingoTopSliderHeader">
                    <span>{debateInfo?.question}</span>
                  </div>
                </div>
                <div className="BingoButtonWrapper flex flex-col gap-10px  items-center container-view-student">
                  <div className="align-self-end play-theme-song-container">
                    <PlayThemeSong {...themeSongProps} />
                  </div>
                  <ClickOutside
                    onClickOutside={() => {
                      setViewResultWheel(false);
                      setOpenMyLoteria(false);
                    }}
                  >
                    <div className="flex items-center gap-10px view-button">
                      <ViewMyLoteria
                        MatchType={MatchType}
                        open={openMyLoteria}
                        bingoType={bingoType}
                        bingoData={bingoWheelSpinData}
                        openChange={handleOpenChange}
                        text={"Lotería Spin Display"}
                      />
{/* 
                      <ViewSelectedResultWheel
                        open={viewResultWheel}
                        bingoType={bingoType}
                        bingoData={wheelSpinData}
                        openChange={handleOpenChangeForWheelResult}
                        text={"Selected Lotería from Spin"}
                        viewType="viewResultWheel"
                      /> */}
                    </div>
                  </ClickOutside>
                </div>
              </div>
            </Col>
            <Col xs={24}>
              <div className="topSliderHeaderTxtBingo">
                <span>{debateInfo?.question}</span>
              </div>
            </Col>
            <Col xs={24}>
              <div className="debateStdntDetailSection">
                <div className="text-center">
                  {showNames ? (
                    <p>{currentSubmission?.user_name}</p>
                  ) : (
                    <p>Estudiante</p>
                  )}
                </div>
                <GridView
                  grid={answerText}
                  selectedType={MatchType}
                  readOnly={true}
                  wheelSpinData={wheelSpinData}
                />
              </div>

              <div className="debateCardNavUpr">
                <div className="debatStdntDetail">
                  <span>Show student names</span>
                  <Switch
                    checked={showNames}
                    onClick={(checked) => setShowNames(checked)}
                  />
                </div>
                <div className="debateCardNav bingoAcceptAndRejectBtn">
                  <div className="evaluationButtons">
                    <Button
                      type="primary"
                      onClick={() => handleEvaluationResult("accept")}
                    >
                      {resultLoader === "accept" ? (
                        <LoaderWrapper>
                          <Loading size={18} white />
                        </LoaderWrapper>
                      ) : (
                        "Accept"
                      )}
                    </Button>
                    <Button
                      type="danger"
                      onClick={() => handleEvaluationResult("reject")}
                    >
                      {resultLoader === "reject" ? (
                        <LoaderWrapper>
                          <Loading size={18} white />
                        </LoaderWrapper>
                      ) : (
                        "Reject"
                      )}
                    </Button>
                  </div>
                  <button
                    className={`debateNavbtn debateNavPre ${
                      currentQuestionIndex === 0 ? "btnDisabled" : ""
                    }`}
                    onClick={handlePrev}
                    disabled={currentQuestionIndex === 0}
                  >
                    <img src={DebateLftIcon} alt="Debate" />
                  </button>
                  <button
                    className={`debateNavbtn debateNavNxt ${
                      currentQuestionIndex === studentSubmission?.length - 1
                        ? "btnDisabled"
                        : ""
                    }`}
                    onClick={handleNext}
                    disabled={
                      currentQuestionIndex === studentSubmission?.length - 1
                    }
                  >
                    <img src={DebateRgtIcon} alt="Debate" />
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </SentryWrap>
  );
};

const styles = {
  gridContainer: (gridLength) => ({
    display: "grid",
    gridTemplateColumns: `repeat(${gridLength}, 150px)`,
    border: "3px dashed #080808",
    borderRadius: "4px",
    overflow: "auto",
    gap: "0",
  }),
  cell: (
    selectedType,
    isLastRow,
    isLastColumn,
    backgroundColor,
    cellSelected
  ) => ({
    width: "150px",
    height: (selectedType === "Image" || selectedType === "OnlyImage") ? "auto" : "150px",
    minHeight: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    overflow: "hidden",
    position: "relative",
    cursor: "pointer",
    backgroundColor: cellSelected ? "#d3f9d8" : backgroundColor,
    flexDirection: (selectedType === "Image" || selectedType === "OnlyImage") ? "column" : "row",
    gap: (selectedType === "Image" || selectedType === "OnlyImage") ? "10px" : "0",
    borderRight: isLastColumn ? "none" : "3px dashed #080808",
    borderBottom: isLastRow ? "none" : "3px dashed #080808",
    color: cellSelected ? "#000" : "#fff",
  }),
  cell2: (
    selectedType,
    isLastRow,
    isLastColumn,
    backgroundColor,
    cellSelected
  ) => ({
    width: "150px",
    height: (selectedType === "Image" || selectedType === "OnlyType") ? "auto" : "150px",
    minHeight: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    overflow: "hidden",
    position: "relative",
    cursor: "pointer",
    backgroundColor: cellSelected ? "#d3f9d8" : backgroundColor,
    flexDirection: (selectedType === "Image" || selectedType === "OnlyType") ? "column" : "row",
    gap: (selectedType === "Image" || selectedType === "OnlyType") ? "10px" : "0",
    borderRight: isLastColumn ? "none" : "3px dashed #080808",
    borderBottom: isLastRow ? "none" : "3px dashed #080808",
    color: "#fff",
  }),
};

export default BingoStudentDetail;
